import { useEffect, useRef, type ReactNode } from 'react'
import { Heading } from './Heading'
import { IconButton } from './IconButton'
import { CloseIcon } from './icons'
import styles from './Modal.module.css'

export interface ModalProps {
  opened: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

/* Native <dialog> so focus trapping, Escape and the backdrop come for free. */
export function Modal({ opened, onClose, title, children }: ModalProps) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (opened && !el.open) el.showModal?.()
    if (!opened && el.open) el.close()
  }, [opened])

  return (
    <dialog
      ref={ref}
      className={styles.dialog}
      aria-label={title}
      onCancel={(e) => { e.preventDefault(); onClose() }}
      onClick={(e) => { if (e.target === ref.current) onClose() }}
    >
      {opened && (
        <>
          <div className={styles.head}>
            <Heading level={3}>{title}</Heading>
            <IconButton label="Close" icon={<CloseIcon />} size="sm" onClick={onClose} />
          </div>
          <div className={styles.body}>{children}</div>
        </>
      )}
    </dialog>
  )
}
